import fondsskoleReducer, { type FondsskoleState, type Fondsskole } from "./fondsskoleReducer";

export type { FondsskoleState, Fondsskole };

export default fondsskoleReducer;
